import _en from './en';
import fr from './fr';
let enData = {};
Object.keys(_en).forEach(k => {
  enData[k] = _en[k] || k;
});
export const EN = enData;
export const FR = fr;
